import request from "@/utils/request";
export function getChatRootCache() {
  /* let chatRoot = Cookies.get(chatRootKey)
  console.log('chatRoot', chatRoot);
  if(!chatRoot){
    return '/chatxfyun'
  }
  return chatRoot */
  return "/chatgpt";
}

// 查询充值套餐列表
export function listCombo() {
  return request({
    url: "/chatBase/combo/comboList",
    method: "get",
  });
}

// 发送GPT生成内容
export function getContent(data: {
  prompt: any;
  sessionId: number;
  themeId: number;
  languageName: any;
}) {
  return request({
    url: getChatRootCache() + "/PPT/getContent",
    method: "post",
    data: data,
  });
}

// 查询页数据
export function getPageContent(data: { key: any; index: number }) {
  return request({
    url: getChatRootCache() + "/PPT/getPageContent",
    method: "get",
    params: data,
  });
}

// 查询页数据
export function getPageDisContent(data: { key: any }) {
  return request({
    url: getChatRootCache() + "/PPT/getPageDisContent/" + data.key,
    method: "get",
  });
}

export function saveContent(data: { content: any; sessionId: number }) {
  return request({
    url: "/chatBase/message/saveContent",
    method: "post",
    data: data,
  });
}

// 查询PPT配图分类
export function getPPTImageTypeList(data: { parentId: number }) {
  return request({
    url: "/chatBase/pptImgType/getTypeList",
    method: "get",
    params: data,
  });
}
// 查询分类下所有配图信息
export function getTypeImgList(data: { parentId: number; id: number }) {
  return request({
    url: "/chatBase/pptImgType/getTypeImgList",
    method: "get",
    params: data,
  });
}

export function getFreeAndTokens() {
  return request({
    url: "/chatBase/give/getFreeAndTokens",
    method: "post",
  });
}

export function getUserCanChat() {
  return request({
    url: "/chatBase/give/getUserCanChat/3",
    method: "post",
  });
}

export function getPromotionCode() {
  return request({
    url: "/chatBase/branchInfo/getPromotionCode",
    method: "get",
  });
}

export function getUserCanChatAndDownLoad(id: any) {
  return request({
    url: "/chatBase/give/getUserCanChatAndDownLoad/3/" + id,
    method: "post",
  });
}

export function getUserPptInfo(id: any) {
  return request({
    url: "/chatBase/userPpt/getInfo/" + id,
    method: "get",
  });
}

export function getNewPageContent(data: {
  prompt: any;
  title: any;
  languageName: any;
  key: any;
}) {
  return request({
    url: getChatRootCache() + "/PPT/reContent",
    method: "post",
    data: data,
  });
}

export function getPageContentByKey(data: { key: any; pageId: any }) {
  return request({
    url: getChatRootCache() + "/PPT/getReContent",
    method: "post",
    data: data,
  });
}

// export function uploadFile(data: any) {
//   return request({
//     url: '/file/headPage/upload',
//     method: 'post',
//     data: data,
//     headers: {'Content-Type': 'multipart/form-data'}
//   })
// }
export function uploadFile(data: any, id: string) {
  return request({
    url: `/file/uploadPptImg/${id}`,
    method: "post",
    data: data,
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function uploadPreviewFile(data: any) {
  return request({
    url: "/file/preview/upload",
    method: "post",
    data: data,
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function updateImg(data: { id: string; img: string }) {
  return request({
    url: "/chatBase/userPpt/updateImg",
    method: "put",
    data: data,
  });
}

export function getPreviewJson(data: { id: number }) {
  return request({
    url: "/chatBase/themeTemplate/getPreviewJson/" + data.id,
    method: "get",
  });
}

export function updatePreview(data: { id: number; preview: string }) {
  return request({
    url: "/chatBase/themeTemplate/updatePreview",
    method: "put",
    data: data,
  });
}

export function getSliderInfoList(data: {
  id: any;
  pageNum: any;
  pageSize: number;
}) {
  return request({
    url: "/chatBase/userPptInfo/sliderInfoList",
    method: "get",
    params: data,
  });
}

export function savePptInfo(data: any) {
  return request({
    url: "/chatBase/userPptInfo/savePptInfo",
    method: "post",
    data: data,
  });
}

//保存ppt接口迭代
export function savePptInfoV2(data: any) {
  return request({
    url: "/chatBase/userPptInfo/savePptInfoList",
    method: "post",
    data: data,
  });
}
export function saveClickData(data: any) {
  return request({
    url: "/chatBase/clickData/add",
    method: "post",
    data: data,
  });
}

export function getTemplateList(data: {
  pageNum: any;
  pageSize: any;
  styleId?: any;
  tenantId?: any;
}) {
  return request({
    url: "/chatBase/themeTemplate/page",
    method: "get",
    params: data,
  });
}

export function changeTemplate(data: any) {
  return request({
    // url: '/chatgpt/PPT/v2/changeTemplate',
    url: "/chatBase/PPT/changeTemplate",
    method: "post",
    data: data,
  });
}
// 获取用户有没有成功下载
export function getUserDownloadStatus(data: {
  id: string;
  downloadStatus: number;
}) {
  return request({
    url: "/chatBase/userPpt/download",
    method: "post",
    data: data,
  });
}

// 当前ppt有没有分享权限
export function getPptShareAuth(data: {
  id: any;
  pageNum: any;
  pageSize: number;
}) {
  return request({
    url: "/chatBase/userPptInfo/shareSliderInfoList",
    method: "get",
    params: data,
  });
}

// 用户点击分享ppt
export function setPptShareAuth(data: { userPptId: string }) {
  return request({
    url: "/chatBase/userPptShare/share",
    method: "post",
    data: data,
  });
}

export function getPptThemeStyleByLanguage(data: string) {
  return request({
    url: `/chatBase/themeStyle/getPptThemeStyleByLanguage?language=${data}`,
    method: "get",
  });
}
